import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "4f76332f-798f-45bb-a7b8-83d869286233",
    authority:
      "https://login.microsoftonline.com/7e8b4324-af16-4828-a220-2e98ad6e3118", // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: "/", // Points to window.location.origin.
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    clientCapabilities: ["CP1"], // this lets the resource owner know that this client is capable of handling claims challenge.
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  // Interactive sign-in is OIDC-only. Do not request delegated Microsoft Graph
  // or Dataverse permissions at login: those consent prompts are unnecessary
  // for authentication and can require tenant-admin approval. Feature API
  // tokens are acquired separately only when a signed-in coach uses a feature.
  scopes: [],
};
